module.exports = __webpack_public_path__ + "static/media/YF83_10.8931e1da.jpg";